export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "http://localhost:4000/";
export const recaptcha_token = process.env.REACT_APP_RECAPTCHA_TOKEN;
export const PLATFORM = process.env.REACT_APP_PLATFORM;
export const AVATAR_URL = API_URL + "files/avatars/";
export const APP_URL = process.env.REACT_APP_APP_URL;
export const STORE_KEY = process.env.REACT_APP_STORE_KEY;
export const AVIS_SITUATION_URL = process.env.REACT_APP_AVIS_SITUATION_URL;
